import {
    exclusivePageLayoutContentsStyle,
    exclusivePageLayoutStyle,
    mainContentStyle,
    sidebarStyle,
} from "@/component-library/components/page-layouts/exclusive/ExclusivePageLayout.css";
import { clsx } from "clsx";
import React from "react";

interface ExclusiveLayoutProps {
    header?: React.ReactNode;
    children: React.ReactNode;
    sidebar?: React.ReactNode;
    sidebarPosition?: "left" | "right";
    splitLine?: boolean;
    sidebarVariant?: "small";
    /**
     * Goes on the outermost element, which is the only one that has both the
     * content and the sidebar under it -- so a page with something to say
     * about every part of itself at once (see the booking page's field sizing)
     * has somewhere to say it.
     */
    className?: string;
}

/**
 * For content that takes the entire page. [ExclusiveLayoutContents] can be
 * used to wrap content inside the page, providing a scrollable and styled
 * setup for content.
 * @param header
 * @param children
 * @param sidebar
 * @param sidebarPosition
 * @param splitLine
 * @param sidebarVariant
 * @param className
 * @constructor
 */
const ExclusivePageLayout: React.FC<ExclusiveLayoutProps> = ({
    header,
    children,
    sidebar,
    sidebarPosition = "right",
    splitLine = false,
    sidebarVariant,
    className,
}) => {
    return (
        <div className={clsx(exclusivePageLayoutStyle, className)}>
            {header}
            <div className={clsx(exclusivePageLayoutContentsStyle)}>
                {sidebar && sidebarPosition === "left" && (
                    <aside
                        className={sidebarStyle({
                            size: sidebarVariant,
                        })}
                    >
                        {sidebar}
                    </aside>
                )}

                <main
                    className={mainContentStyle}
                    data-border-left={splitLine && sidebarPosition === "left"}
                    data-border-right={splitLine && sidebarPosition === "right"}
                >
                    {children}
                </main>
                {sidebar && sidebarPosition === "right" && (
                    <aside
                        className={sidebarStyle({
                            size: sidebarVariant,
                        })}
                    >
                        {sidebar}
                    </aside>
                )}
            </div>
        </div>
    );
};

export default ExclusivePageLayout;
